import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    searchClear: 'Clear',
    searchPlaceholder: 'Search by invoice number or title, client...',
    submit: 'Add to transaction',
    title: 'Link your invoices to your transactions.',
  },
  fr: {
    cancel: 'Annuler',
    searchClear: 'Effacer',
    searchPlaceholder: 'Recherche par numéro ou titre de facture, client·e...',
    submit: 'Ajouter à la transaction',
    title: 'Liez vos factures à vos transactions.',
  },
} as const);

export default locales;
